// extracted by mini-css-extract-plugin
export default {"text":"CancelAutoRenewTrialModal__text--3NlEH","caption":"CancelAutoRenewTrialModal__caption--1Zjbg"};